<template>
  <el-dialog
      custom-class="payment-modal"
      width="500px"
      destroy-on-close
      @close="closeModal"
      :visible="isVisible"
      :fullscreen="$mq === 'xs'"
      >
      <div slot='title'>
        <h4 class="title title-up">{{$t('Autopayment')}}</h4>
      </div>
      <form ref="form" class="payment-form" @submit.prevent="submitPayment">
        <div>{{ $t('Agreement') }}</div>
        <el-select
          v-model="agrmId"
          class="agreement-select">
          <el-option
            v-for="(agreement) in agreements"
            :key="agreement.id"
            :label="agreement.number"
            :value="agreement.id">
          </el-option>
        </el-select>
        <fg-input
          name="sum"
          :label="$t('Sum')"
          v-model="sum"
          v-validate="'required|decimal:2'"
          :error="getError('sum')"
        >
          <template v-slot:infoBlock v-if="recommendedPayment !== null">
            <div class="form-text recommended-payment">
              <span class="recommended-payment__title">{{`${$t('Amount of subscriptions')}: `}}</span>
              <span @click="onClickRecommendedSum" v-bind:class="{ linqqqq: recommendedPayment }">{{recommendedPaymentString}}</span>
            </div>
          </template>
        </fg-input>
        <fg-input
          name="email"
          type="email"
          :label="$t('Email')"
          v-validate="'required|email'"
          v-model="email"
          :error="getError('email')"
        >
          <template v-slot:infoBlock>
            <span class="form-text">{{$t('Enter your E-Mail to receive an digital receipt')}}</span>
          </template>
        </fg-input>
        <div class="period-params">
          <fg-input
            name="dayOfMonth"
            :label="$t('Day of the month')"
            v-validate="'required|min_value:1|max_value:31'"
            v-model="dayOfMonth"
            :error="getError('dayOfMonth')"
          >
          </fg-input>
          <fg-input
            name="period"
            :label="$t('Charge period in months')"
            v-validate="'required|min_value:1'"
            v-model="period"
            :error="getError('period')"
          />
        </div>
        <div class="autopay-description">
          <p>Для сохранения метода оплаты мы спишем небольшую сумму и вернём её.</p>
          <p>Первый платёж спишется <span class="pay-date">{{ nextPaymentDate }}</span>.</p>
        </div>
        <div class="dialog-footer">
          <el-button plain class="payment-cancel-button" @click.native="closeModal">{{ $t('Cancel') }}</el-button>
          <el-button type="primary" nativeType="submit" :loading="loading" >{{ $t('Create') }}</el-button>
        </div>
      </form>
    </el-dialog>
</template>

<script>
import axios from 'axios'
import { Button } from 'element-ui'
import { Decimal } from 'decimal.js'
import { mapState } from 'vuex'
import { format } from 'date-fns'
import { ru, az } from 'date-fns/locale'
import { getSubscriptions } from '../utils/api'
import number from './mixins/number'

export default {
  name: 'AutopaymentModal',
  mixins: [number],
  components: {
    [Button.name]: Button
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    onCloseModal: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      agreements: [],
      agrmId: null,
      sum: null,
      recommendedPayment: null,
      email: '',
      dayOfMonth: 1,
      period: 1,
      paymentId: null,
      opened: false,
      loading: false
    }
  },
  mounted() {
    this.$store.dispatch('getProfile').then(() => {
      if (!this.profile.email) {
        return
      }
      this.email = this.profile.email
    })

    this.getAgreements()
  },
  watch: {
    agrmId: function () {
      this.getSubscriptionsSum()
    }
  },
  methods: {
    getSubscriptionsSum: function() {
      getSubscriptions(this.agrmId)
        .then(subscriptions => {
          if (!subscriptions.length) {
            return
          }
          const sum = subscriptions.reduce(function(a, b) {
            return parseFloat(Decimal.add(a, b['monthly_cost']))
          }, 0)
          this.sum = this.formatPrice(sum)
          this.recommendedPayment = sum
        })
        .catch(error => {
          console.log('Error fetching subscriptions:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getAgreements: function() {
      axios.get('agreements').then(promise => {
        this.agreements = promise.data.results
        console.log('test', this.agrmId)
        if (!this.agrmId && promise.data.results.length) {
          console.log('test2')
          this.agrmId = promise.data.results[0].id
        }
      })
    },
    closeModal() {
      this.onCloseModal()
    },
    getError(fieldName) {
      return this.$t(this.errors.first(fieldName))
    },
    onClickRecommendedSum: function() {
      this.sum = this.recommendedPayment
    },
    submitPayment: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const params = {
            autopaymentSum: this.sum,
            email: this.email,
            agrmnum: this.currentAgreement.number,
            agrmid: this.agrmId,
            provider: 'yookassa',
            returnUrl: window.location.origin + window.location.pathname,
            dayOfMonth: this.dayOfMonth,
            period: this.period,
            isAutopayment: true,
            cancelPayment: true
          }
          this.loading = true
          axios
            .post('payments/create', params)
            .then(promise => {
              window.location.replace(
                promise.data.results
              )
            })
            .catch(error => {
              this.loading = false
              console.log('error: ', error.response)
              var errorMessage = error.response.data.error
              this.$notify(
                {
                  message: errorMessage,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger',
                  timeout: 1500
                })
            })
        }
      })
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.data,
      profile: state => state.profile.credentials,
      noContacts: state => !state.profile.credentials.email && !state.profile.credentials.mobile
    }),
    currentAgreement() {
      if (!this.agrmId || !this.agreements.length) {
        return null
      }
      return this.agreements.find(agreement => agreement.id === this.agrmId)
    },
    recommendedPaymentString: function() {
      const currency = this.currentAgreement.currency
      return `${this.recommendedPayment} ${currency}`
    },
    nextPaymentDate: function() {
      const locale = this.$i18n.locale === 'az' ? az : ru
      var currentDate = new Date()
      var year = currentDate.getFullYear()
      var month = currentDate.getMonth()
      var currentDay = currentDate.getDate()
      const date = new Date(year, currentDay > this.dayOfMonth ? month + 1 : month, this.dayOfMonth)
      return format(date, 'd MMMM yyyy', { locale: locale })
    }
  }
}
</script>

<style scoped>

.agreement-select {
  width: 100%;
  margin-bottom: 10px;
}

.autopay-description {
  color: #9A9A9A;
  margin-bottom: 0;
}
.autopay-description p {
  margin-bottom: 0.2rem;
}
</style>
